import {
  AnalyticsIcon
} from "@/components/icons";
import React, { FC } from "react";
import { CgFileDocument } from "react-icons/cg";
import { RiUserCommunityFill } from "react-icons/ri";
import { IoPersonCircleOutline } from "react-icons/io5";
import { SideBarRouteOption, ISidebarProps } from "@/types";

// Wrapper components to handle isActive prop for react-icons
const FileDocumentIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(CgFileDocument, props);

const UserCommunityIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(RiUserCommunityFill, props);

const PersonCircleIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(IoPersonCircleOutline, props);

export const getLicencingEndUserRoutes = (t: (key: string) => string): SideBarRouteOption[] => [
  {
    name: t("navigation.analytics"),
    path: "/end-user-account",
    icon: AnalyticsIcon,
  },
  {
    name: t("navigation.applications"),
    path: "/end-user-account/Certificates",
    icon: FileDocumentIcon,
  },
  {
    name: t("navigation.examinations"),
    path: "/end-user-account/examinations",
    icon: FileDocumentIcon,
  },
  {
    name: t("navigation.myProfile"),
    path: "/end-user-account/user-profile-record",
    icon: UserCommunityIcon,
  },
];

// Keep the old export for backward compatibility
const licencingAdminRoutes: SideBarRouteOption[] = [
  {
    name: "Analytics",
    path: "/end-user-account",
    icon: AnalyticsIcon,
  },
  {
    name: "Applications",
    path: "/end-user-account/Certificates",
    icon: FileDocumentIcon,
  },
  {
    name: "Examinations",
    path: "/end-user-account/examinations",
    icon: FileDocumentIcon,
  },
  {
    name: "My Profile",
    path: "/end-user-account/user-profile-record",
    icon: UserCommunityIcon,
  },
];

export default licencingAdminRoutes;
